import React, { useState,useEffect } from 'react';
import "./imageUpload.scss"
import { DeleteIcon} from "../../../components/Icons";
import { toast } from "react-toastify";

const ImageUpload = ({ index, handleServiceImages, maxImages = 5,resetImages, handleImagesReset }) => {
  const [images, setImages] = useState([]);
  useEffect(() => {
    if (resetImages && resetImages === true) {
      setImages([]);
      handleImagesReset();
    }
  }, [resetImages, handleImagesReset]);
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length + images.length > maxImages) {
      toast.warning(`You can only upload a maximum of ${maxImages} images.`, {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    setImages([...images, ...files]);
    handleServiceImages(index, [...images, ...files]);
  };

  const handleRemoveImage = (indexToRemove) => {
    const filteredImages = images.filter((_, index) => index !== indexToRemove);
    setImages(filteredImages);
    handleServiceImages(index, filteredImages);
  };

  return (
    <div>
      <input
        type="file"
        multiple
        accept="image/*"
        onChange={handleImageChange}
        style={{ display: 'none' }}
        id={`imageUpload_${index}`}
      />
      <div className="image-preview">
        {images.map((file, i) => (
          <div key={i} className="image-preview-item">
            <div className="img-preview">

            
            <img src={URL.createObjectURL(file)} alt={`Preview ${i + 1}`}  style={{ maxWidth: '100px', maxHeight: '100px' }} />
            </div>
            <div className="img-remove-btn">
            <div className="delete-icon" onClick={() => handleRemoveImage(i)}><DeleteIcon/></div>
            
            </div>
          </div>
        ))}
      </div>
      <div className='add-image-btn'>
      <label htmlFor={`imageUpload_${index}`} className="image-upload-label" variant="primary">
          Add Images
        </label>
      </div>
    </div>
  );
};

export default ImageUpload;
